import LeaveRequestList from "./pages/ListPage.vue";
import LeaveRequestDetail from "./pages/FormPage.vue";
import LeaveRequestIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/leave_request",
    component: LeaveRequestIndex,
    redirect: "/leave_request/list",
    name: "leave_request",
    children: [
      {
        path: "list",
        component: LeaveRequestList,
        name: "leave_request.list",
      },
      {
        path: "create",
        component: LeaveRequestDetail,
        name: "leave_request.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: LeaveRequestDetail,
        name: "leave_request.edit",
        props: { create: false },
      },
    ],
  },
];
